import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import useStore from 'store';
import { useTranslation } from 'react-i18next';
import PageContainer from 'components/@layout/PageContainer';
import ApplicationDetails from './components/ApplicationDetails';
import HeaderBar from '../HeaderBar';
import { ModuleProps } from 'types';

import getApplicationType from 'utilities/get-application-type';
const AppAccess: React.FC<ModuleProps> = props => {
  const { t } = useTranslation('AppAccess');
  const match = useRouteMatch<{ productCodeOrAppName: string }>();
  const { productCodeOrAppName } = match.params;
  const [{ productCache }] = useStore();

  let app = productCache.findAppByProductCode(productCodeOrAppName.toLocaleUpperCase());
  if (!app) {
    app = productCache
      .getApps()
      .find(pliManagedApp => pliManagedApp.app.name === productCodeOrAppName);
  }

  const appType = app?.type && t(getApplicationType([app.type]));

  return (
    <PageContainer loading={!app}>
      <HeaderBar {...props} />
      {app && (
        <ApplicationDetails
          appName={t(app.title)}
          appDescription={app.description && t(app.description)}
          appImage={app.accessDetails?.bannerUrl}
          appType={appType}
          sectionOneHeader={t(app.purchaseDetails?.title || '')}
          sectionOneDetails={t(app.purchaseDetails?.description || '')}
          sectionTwoHeader={t('Have Questions? Try our Help & Support page.')}
          sectionTwoDetails={
            <>
              {t(
                `If you can't find your answer, contact us through live chat, send us a message or give us a call at `
              )}
              <b>888-983-8409</b>.
            </>
          }
          accessButtonOneLabel={t('Access Web Application')}
          accessButtonTwoLabel={t('Access iOS Application')}
          sectionOneButtonLink={app.purchaseDetails?.url}
          accessButtonOneLink={app.accessDetails?.url}
          accessButtonTwoLink={app.accessDetails?.iosUrl}
        />
      )}
    </PageContainer>
  );
};

export default AppAccess;
